module.exports = __webpack_public_path__ + "img/bgc1.f37691bf.png";